define('OutSystems/ReactWidgets/Popover',["require", "exports", "tslib", "OutSystems/ReactView/Widget", "react", "react-dom", "./Utils"], function (require, exports, tslib_1, Widget_1, React, react_dom_1, Utils_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.Popover = exports.IPopoverAnchorState = void 0;
    var IPopoverAnchorState;
    (function (IPopoverAnchorState) {
        IPopoverAnchorState[IPopoverAnchorState["Start"] = 0] = "Start";
        IPopoverAnchorState[IPopoverAnchorState["Middle"] = 1] = "Middle";
        IPopoverAnchorState[IPopoverAnchorState["End"] = 2] = "End";
    })(IPopoverAnchorState = exports.IPopoverAnchorState || (exports.IPopoverAnchorState = {}));
    var Popover = (function (_super) {
        tslib_1.__extends(Popover, _super);
        function Popover(props, context) {
            var _this = _super.call(this, props, context) || this;
            _this.bottomPlaceholderRef = React.createRef();
            _this.anchorRef = React.createRef();
            _this.verticalAnchor = null;
            _this.horizontalAnchor = null;
            _this.screenContainer = "screen-container";
            _this.getCoords = function () {
                var anchorBoundingRect = _this.anchorRef.current.getBoundingClientRect();
                var popoverBottomRect = _this.bottomPlaceholderRef.current.getBoundingClientRect();
                var horizontalAnchor = _this.horizontalAnchor;
                var verticalAnchor = _this.verticalAnchor;
                var newLeft = anchorBoundingRect.left + anchorBoundingRect.width / 2 - popoverBottomRect.width / 2 + "px";
                var newRight = "";
                var newTop = anchorBoundingRect.top + "px";
                var newBottom = "";
                if (horizontalAnchor !== null && verticalAnchor !== null) {
                    if (horizontalAnchor === IPopoverAnchorState.Start) {
                        newLeft = anchorBoundingRect.left + "px";
                    }
                    else if (horizontalAnchor === IPopoverAnchorState.End) {
                        newLeft = "";
                        newRight = window.innerWidth - anchorBoundingRect.right + "px";
                    }
                    if (verticalAnchor === IPopoverAnchorState.End) {
                        newTop = "";
                        newBottom = window.innerHeight - anchorBoundingRect.bottom + "px";
                    }
                }
                var newCoords = {
                    newLeft: newLeft,
                    newRight: newRight,
                    newTop: newTop,
                    newBottom: newBottom,
                };
                return newCoords;
            };
            _this.updateCoords = function () {
                var _a = _this.getCoords(), newLeft = _a.newLeft, newRight = _a.newRight, newTop = _a.newTop, newBottom = _a.newBottom;
                var _b = _this.state.coords, left = _b.left, right = _b.right, top = _b.top, bottom = _b.bottom;
                if (left !== newLeft || right !== newRight || top !== newTop || bottom !== newBottom) {
                    _this.setState({
                        coords: {
                            left: newLeft,
                            right: newRight,
                            top: newTop,
                            bottom: newBottom,
                        },
                    });
                }
            };
            _this.debouncedUpdateCoords = Utils_1.debounce(_this.updateCoords);
            _this.outerOnClickHander = function (event) {
                if (!_this.isElementInsidePopover(event.target)) {
                    _this.unregisterEvents();
                    _this.horizontalAnchor = null;
                    _this.verticalAnchor = null;
                    _this.setState({
                        expanded: false,
                        anchored: false,
                    });
                }
            };
            _this.focusFirstFocusableElement = _this.focusFirstFocusableElement.bind(_this);
            _this.state = {
                expanded: false,
                coords: {
                    left: "",
                    top: "",
                    right: "",
                    bottom: "",
                },
                anchored: false,
                popoverParent: null,
            };
            _this.prevExpanded = _this.state.expanded;
            return _this;
        }
        Popover.prototype.show = function (event) {
            event.stopPropagation();
            this.registerEvents();
            this.setState({
                expanded: true,
            });
        };
        Popover.prototype.hide = function (event) {
            event.stopPropagation();
            this.unregisterEvents();
            this.horizontalAnchor = null;
            this.verticalAnchor = null;
            this.setState({
                expanded: false,
                anchored: false,
            });
        };
        Popover.prototype.registerEvents = function () {
            document.addEventListener("click", this.outerOnClickHander, { capture: true });
            window.addEventListener("resize", this.debouncedUpdateCoords);
            window.addEventListener("scroll", this.updateCoords, { capture: true });
        };
        Popover.prototype.unregisterEvents = function () {
            document.removeEventListener("click", this.outerOnClickHander, { capture: true });
            window.removeEventListener("resize", this.debouncedUpdateCoords);
            window.removeEventListener("scroll", this.updateCoords, { capture: true });
        };
        Popover.prototype.isElementInsidePopover = function (element) {
            var popover = this.bottomPlaceholderRef.current;
            return popover && element && (element === popover || popover.contains(element));
        };
        Popover.prototype.adjustPositionBasedOnViewport = function () {
            if (this.state.expanded) {
                var popoverBottom = this.bottomPlaceholderRef.current;
                if (!this.state.anchored) {
                    var _a = this.getCoords(), newLeft = _a.newLeft, newRight = _a.newRight, newTop = _a.newTop, newBottom = _a.newBottom;
                    this.setState({
                        coords: {
                            left: newLeft,
                            right: newRight,
                            top: newTop,
                            bottom: newBottom,
                        },
                        anchored: true,
                    });
                }
                else if (this.horizontalAnchor === null && this.verticalAnchor === null) {
                    var horizontalAnchor = IPopoverAnchorState.Middle;
                    var verticalAnchor = IPopoverAnchorState.Start;
                    var boundingRect = popoverBottom.getBoundingClientRect();
                    if (boundingRect.left < 0) {
                        horizontalAnchor = IPopoverAnchorState.Start;
                    }
                    else if (boundingRect.right > window.innerWidth) {
                        horizontalAnchor = IPopoverAnchorState.End;
                    }
                    if (boundingRect.bottom > window.innerHeight) {
                        verticalAnchor = IPopoverAnchorState.End;
                    }
                    this.horizontalAnchor = horizontalAnchor;
                    this.verticalAnchor = verticalAnchor;
                }
                this.updateCoords();
            }
        };
        Popover.prototype.componentDidUpdate = function () {
            this.adjustPositionBasedOnViewport();
            if (this.state.expanded !== this.prevExpanded) {
                this.prevExpanded = this.state.expanded;
                this.focusFirstFocusableElement();
            }
        };
        Popover.prototype.setParentComponent = function () {
            var _this = this;
            var popover = this.anchorRef.current;
            Array.from(document.getElementsByClassName(this.screenContainer)).forEach(function (element) {
                if (element.contains(popover)) {
                    _this.setState({
                        popoverParent: element,
                    });
                }
                else {
                    _this.setState({
                        popoverParent: popover.parentElement,
                    });
                }
            });
        };
        Popover.prototype.componentDidMount = function () {
            this.setParentComponent();
            this.adjustPositionBasedOnViewport();
        };
        Popover.prototype.componentWillUnmount = function () {
            this.unregisterEvents();
        };
        Popover.prototype.preparePopoverAttributes = function () {
            var popoverAttributes = {
                "data-popover": "",
                className: this.props.style,
            };
            this.fillWithBuiltinProperties(popoverAttributes);
            if (this.state.expanded) {
                popoverAttributes.className += " popover-expanded";
            }
            return popoverAttributes;
        };
        Popover.prototype.preparePopoverTopPlaceholderAttributes = function () {
            var _this = this;
            var popoverTopAttributes = {
                className: "popover-top",
                onClick: function (event) { return _this.show(event); },
                onKeyDown: function (event) {
                    if (event.key === Utils_1.KeyboardKey.ENTER_KEY || event.key === Utils_1.KeyboardKey.SPACE_KEY) {
                        _this.show(event);
                    }
                    else if (_this.state.expanded && event.key === Utils_1.KeyboardKey.ESCAPE_KEY) {
                        _this.hide(event);
                    }
                },
                tabIndex: 0,
                ref: this.anchorRef,
            };
            return popoverTopAttributes;
        };
        Popover.prototype.preparePopoverBottomPlaceholderAnchorAttributes = function () {
            var _a = this.state.coords, left = _a.left, top = _a.top, right = _a.right, bottom = _a.bottom;
            var currentRef = this.bottomPlaceholderRef.current;
            var zindex = currentRef ? getComputedStyle(currentRef.firstElementChild)["z-index"] : "";
            var popoverStyle = {
                position: "fixed",
                width: "max-content",
                left: left,
                top: top,
                right: right,
                bottom: bottom,
                zIndex: zindex,
            };
            var popoverAttributes = {
                "data-popover": "",
                style: popoverStyle,
                className: this.props.style,
                ref: this.bottomPlaceholderRef,
            };
            return popoverAttributes;
        };
        Popover.prototype.preparePopoverBottomPlaceholderAttributes = function () {
            var _this = this;
            var popoverStyle = {
                width: this.props.popoverWidth ? this.props.popoverWidth + "px" : "",
            };
            var popoverBottomAttributes = {
                className: "popover-bottom ",
                style: popoverStyle,
                onClick: function (event) { return _this.hide(event); },
                onKeyDown: function (event) {
                    if (event.key === Utils_1.KeyboardKey.ESCAPE_KEY) {
                        _this.hide(event);
                    }
                },
            };
            return popoverBottomAttributes;
        };
        Popover.prototype.focusFirstFocusableElement = function () {
            if (this.state.expanded) {
                var htmlNode = this.bottomPlaceholderRef.current;
                if (htmlNode) {
                    var element = htmlNode.querySelector("input, button, textarea, select, a");
                    if (element) {
                        element.focus();
                    }
                }
            }
        };
        Popover.prototype.render = function () {
            var topContent = (React.createElement("div", tslib_1.__assign({}, this.preparePopoverTopPlaceholderAttributes()), this.props.placeholders.topContent.render()));
            var bottomContent = this.state.expanded ? (React.createElement("div", tslib_1.__assign({}, this.preparePopoverBottomPlaceholderAnchorAttributes()),
                React.createElement("div", tslib_1.__assign({}, this.preparePopoverBottomPlaceholderAttributes()), this.props.placeholders.bottomContent.render()))) : null;
            return (React.createElement("div", tslib_1.__assign({}, this.preparePopoverAttributes()),
                topContent,
                this.state.popoverParent ? react_dom_1.createPortal(bottomContent, this.state.popoverParent) : null));
        };
        Popover = tslib_1.__decorate([
            Widget_1.WidgetSpec
        ], Popover);
        return Popover;
    }(Widget_1.Widget));
    exports.Popover = Popover;
});
//# sourceMappingURL=Popover.js.map;
